/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2026, Bulb Inc. For more information, please email contact@hellobulb.com.
 */

/* eslint-disable import/no-extraneous-dependencies */
import { Plugin } from 'ckeditor5';
/* eslint-enable import/no-extraneous-dependencies */
import BulbLinkImageEditing from './bulblinkimageediting';
import BulbLinkImageUI from './bulblinkimageui';

/** Adds CKEditor link behavior to Bulb's custom image model. */
export default class BulbLinkImage extends Plugin {

  public static get pluginName(): string {
    return 'BulbLinkImage' as const;
  }

  public static get requires() {
    return [BulbLinkImageEditing, BulbLinkImageUI] as const;
  }
}
